import React, { FC } from 'react'
import { TertiaryButton } from '@moonpig/launchpad-components'
import { system as s } from '@moonpig/launchpad-system'
import { styled } from '@moonpig/launchpad-utils'
import { spacing } from '@moonpig/launchpad-theme'
import { FilterCategory, IntegerFilter } from '../../../services/types/services'
import { FilterSource } from '../../../types'
import { useFindLocaleText } from '../../../text-localisation'
import { ClearFiltersProps } from '../../../store/slices/filters'

const StyledButton = styled(TertiaryButton)`
  ${s({
    typography: 'typeButtonLabel',
    color: 'colorInteractionTextLink',
    py: 5,
    px: 2,
    textAlign: 'right',
  })}
`
const StyledWrapper = styled.div`
  min-width: ${spacing(12)}px;
`

type Props = {
  level: number
  category?: FilterCategory | IntegerFilter
  type?: 'filters' | 'sort'
  hide: boolean
  source: FilterSource
  clearFilters: ({ source, category, type }: ClearFiltersProps) => void
}

export const ClearButton: FC<Props> = ({
  level,
  category,
  type = 'filters',
  source,
  hide,
  clearFilters,
}) => {
  const localiseText = useFindLocaleText()

  const onClear = () => {
    if (level === 0) {
      clearFilters({ source })
    } else {
      clearFilters({ category, type, source })
    }
  }

  return (
    <StyledWrapper>
      {!hide && (
        <StyledButton
          aria-label={localiseText('find.clear_selection')}
          onClick={() => onClear()}
          as="button"
        >
          {localiseText('find.clear')}
        </StyledButton>
      )}
    </StyledWrapper>
  )
}
